import { Stack } from "@mui/material";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
export var ReturnSummaryPopup = function (_ref) {
    var contractDetails = _ref.contractDetails, width = _ref.width;
    var elements = [{
            type: FormItemTypes.Accordian,
            name: '',
            value: null,
            columnSize: 12,
            sx: {
                border: 'none',
                bgcolor: 'background.secondary'
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: 'regNo',
                    fontWeight: 'strong',
                    columnSize: true
                }, {
                    type: FormItemTypes.Typography,
                    name: 'taxableAmount',
                    fontWeight: 'strong',
                    columnSize: 0
                }],
            detailPanelProps: {
                spacing: 0,
                gap: '12px',
                p: 2,
                borderRadius: 2,
                bgcolor: 'background.secondary'
            },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        border: 'none'
                    },
                    contentProps: {
                        spacing: 1.5
                        // gap: '12px'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Service AMC plan for 2 years',
                            value: '₹ 2600.00',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'base',
                                color: '#505862'
                            },
                            fontWeight: 'strong',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Basic amount',
                            value: '₹ 5,600.00',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 4,
                                    children: 'Discount_1',
                                    fontSize: 'sm',
                                    color: 'text.secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 8,
                                    spacing: 0,
                                    gap: 1,
                                    justifyContent: 'end',
                                    alignItems: 'center',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 0,
                                            value: '9 %',
                                            color: 'secondary',
                                            fontWeight: 'medium'
                                        }, {
                                            type: FormItemTypes.Divider,
                                            name: '',
                                            columnSize: 0,
                                            orientation: 'vertical',
                                            sx: {
                                                height: '12px'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 0,
                                            value: '₹ 500.00'
                                        }]
                                }]
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Charge',
                            value: '₹ 600.00',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Taxable amount',
                            value: '₹ 5,600.00',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 4,
                                    children: 'CGST',
                                    fontSize: 'sm',
                                    color: 'text.secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 8,
                                    spacing: 0,
                                    gap: 1,
                                    justifyContent: 'end',
                                    alignItems: 'center',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 0,
                                            value: '9 %',
                                            color: 'secondary',
                                            fontWeight: 'medium'
                                        }, {
                                            type: FormItemTypes.Divider,
                                            name: '',
                                            columnSize: 0,
                                            orientation: 'vertical',
                                            sx: {
                                                height: '12px'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 0,
                                            value: '₹ 500.00'
                                        }]
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 4,
                                    children: 'SGST',
                                    fontSize: 'sm',
                                    color: 'text.secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 8,
                                    spacing: 0,
                                    gap: 1,
                                    justifyContent: 'end',
                                    alignItems: 'center',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 0,
                                            value: '9 %',
                                            color: 'secondary',
                                            fontWeight: 'medium'
                                        }, {
                                            type: FormItemTypes.Divider,
                                            name: '',
                                            columnSize: 0,
                                            orientation: 'vertical',
                                            sx: {
                                                height: '12px'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 0,
                                            value: '₹ 500.00'
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        border: 'none'
                    },
                    contentProps: {
                        spacing: 0,
                        gap: '12px'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Roadside Assistance',
                            value: '₹ 2600.00',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'base',
                                color: '#505862'
                            },
                            fontWeight: 'strong',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Basic amount',
                            value: '₹ 5,600.00',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Taxable amount',
                            value: '₹ 5,600.00',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between'
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                color: 'text.secondary'
                            },
                            fontWeight: 'medium',
                            columnSize: 12,
                            color: 'text.primary'
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 4,
                                    children: 'CGST',
                                    fontSize: 'sm',
                                    color: 'text.secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 8,
                                    spacing: 0,
                                    gap: 1,
                                    justifyContent: 'end',
                                    alignItems: 'center',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 0,
                                            value: '9 %',
                                            color: 'secondary',
                                            fontWeight: 'medium'
                                        }, {
                                            type: FormItemTypes.Divider,
                                            name: '',
                                            columnSize: 0,
                                            orientation: 'vertical',
                                            sx: {
                                                height: '12px'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 0,
                                            value: '₹ 500.00'
                                        }]
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 4,
                                    children: 'SGST',
                                    fontSize: 'sm',
                                    color: 'text.secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 8,
                                    spacing: 0,
                                    gap: 1,
                                    justifyContent: 'end',
                                    alignItems: 'center',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 0,
                                            value: '9 %',
                                            color: 'secondary',
                                            fontWeight: 'medium'
                                        }, {
                                            type: FormItemTypes.Divider,
                                            name: '',
                                            columnSize: 0,
                                            orientation: 'vertical',
                                            sx: {
                                                height: '12px'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 0,
                                            value: '₹ 500.00'
                                        }]
                                }]
                        }]
                }]
        }];
    var formData = [{
            type: FormItemTypes.Typography,
            name: '',
            value: 'Return summary',
            columnSize: 12,
            fontWeight: 'strong'
        }, {
            type: FormItemTypes.List,
            name: 'orderSummary',
            columnSize: 12,
            disableBorder: true,
            variant: 'expanded',
            value: [{
                    id: 1,
                    "servicePlan": "Service AMC plan for 2 years",
                    "amount": "₹ 2600.00",
                    "basicAmount": "₹ 5,600.00",
                    "discount": {
                        "Discount_1": {
                            "value1": 500,
                            "value2": 1000
                        }
                    },
                    "charge": "₹ 600.00",
                    "taxableAmount": "₹ 5,600.00",
                    "cgst": "₹ 280.00",
                    "igst": "₹ 0.00",
                    "sgst": "₹ 280.00",
                    "regNo": "MH09GH3845"
                }, {
                    id: 2,
                    "servicePlan": "Roadside Assistance",
                    "amount": "₹ 2600.00",
                    "basicAmount": "₹ 5,600.00",
                    "taxableAmount": "₹ 25,000.00",
                    "cgst": "₹ 280.00",
                    "sgst": "₹ 280.00",
                    "regNo": "MH12MS8547"
                }],
            disableCheckboxSelection: true,
            disableDetailsPanel: true,
            getRowHeight: function () { return 'auto'; },
            containerProps: {
                sx: {
                    mb: '16px'
                }
            },
            // columns: [
            //     {
            //         field: 'Labour',
            //         flex: 1,
            //         renderCell: ({ row }) => {
            //             return <Stack direction={'row'} justifyContent={'space-between'}>
            //                 <Typography color={'text.primary'} fontWeight={'medium'}>{'MH50K5632'}</Typography>
            //                 <Typography color='text.primary' fontWeight={'medium'}>{'₹ 35,940.00'}</Typography>
            //             </Stack>
            //         }
            //     },
            // ],
            elements: elements
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            paddingLeft: '12px',
            paddingRight: '32px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 4,
                            children: 'Discount',
                            fontSize: 'sm',
                            color: 'text.secondary',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.NumberInput,
                                    name: 'discountparsentage',
                                    columnSize: 4,
                                    sx: {
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px 0px 0px 8px'
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderRight: 'none !important'
                                        }
                                    },
                                    inputProps: {
                                        endAdornment: '%'
                                    }
                                }, {
                                    type: FormItemTypes.NumberInput,
                                    name: 'discountamount',
                                    columnSize: 8,
                                    sx: {
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '0px 8px 8px 0px'
                                        }
                                    },
                                    inputProps: {
                                        startAdornment: '₹',
                                        style: {
                                            textAlign: 'end'
                                        }
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: 'Charges',
                    value: '0.00',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between'
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'strong',
                        color: 'text.secondary'
                    },
                    fontWeight: 'strong',
                    columnSize: 12,
                    color: 'text.primary'
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: 'Taxable amount',
                    value: '0.00',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between'
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'strong',
                        color: 'text.secondary'
                    },
                    fontWeight: 'strong',
                    columnSize: 12,
                    color: 'text.primary'
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 4,
                            children: 'CGST',
                            fontSize: 'sm',
                            color: 'text.secondary',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            spacing: 0,
                            gap: 1,
                            justifyContent: 'end',
                            alignItems: 'center',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 0,
                                    value: '9 %',
                                    color: 'secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    columnSize: 0,
                                    orientation: 'vertical',
                                    sx: {
                                        height: '12px'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 0,
                                    value: '₹ 500.00'
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 4,
                            children: 'SGST',
                            fontSize: 'sm',
                            color: 'text.secondary',
                            fontWeight: 'medium'
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            spacing: 0,
                            gap: 1,
                            justifyContent: 'end',
                            alignItems: 'center',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 0,
                                    value: '9 %',
                                    color: 'secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    columnSize: 0,
                                    orientation: 'vertical',
                                    sx: {
                                        height: '12px'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    columnSize: 0,
                                    value: '₹ 500.00'
                                }]
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: 'Round- off',
                    value: '0.00',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between'
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'strong',
                        color: 'text.secondary'
                    },
                    fontWeight: 'strong',
                    columnSize: 12,
                    color: 'text.primary'
                }]
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }, {
            type: FormItemTypes.Typography,
            name: '',
            label: 'Net payable amount',
            value: '₹ 1,30,800.00',
            containerProps: {
                display: 'inline-flex',
                justifyContent: 'space-between'
            },
            labelTypographyProps: {
                mb: 0,
                noWrap: true,
                fontWeight: 'strong',
                color: 'text.primary'
            },
            fontWeight: 'strong',
            columnSize: 12,
            color: 'text.primary'
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
        width: width !== null && width !== void 0 ? width : '360px',
        minHeight: "100svh"
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            p: '16px 12px',
            gap: '12px'
        },
        gridSpacing: 0
    })));
};
